import React from "react";
import {connect} from "react-redux";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
//import FormControl from "@material-ui/core/FormControl";

import Link from "@material-ui/icons/Link";
//import FileCopy from "@material-ui/icons/FileCopy";
//import InputAdornment from "@material-ui/core/InputAdornment";

// core components
//import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
//import Card from "components/Card/Card.jsx";
//import CardHeader from "components/Card/CardHeader.jsx";
//import CardIcon from "components/Card/CardIcon.jsx";
//import CardBody from "components/Card/CardBody.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';

import FileCopyOutlined from "@material-ui/icons/FileCopyOutlined";
import {CopyToClipboard} from 'react-copy-to-clipboard';

import Button from "components/CustomButtons/Button.jsx";

import styles from "assets/jss/material-dashboard-pro-react/views/form";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import {
  ibFetch
} from 'actions/ibs'

import {
  referralLinkEditSave,
  referralLinkFetch,
  referralLinksFetch,
  referralLinkSave
} from 'actions/referralLinks'

import {profileFetch} from 'actions/profiles'

import {
  danger,
} from 'actions/notification'

import store from "store/index";

class PartnerLinks extends React.Component {
  constructor(props) {

    super(props);
    
    let configVars = store.getState().config;

    this.state = {
      ibId: this.props.match.params.id,
      profileId: this.props.match.params.id,
      referrallink: configVars['registrationAppUrl']+"0",
      literalId: "",
      referralLinkId: "",
      showCreateReferralLink: true,
      form: {
        ibId: this.props.match.params.id,
        referralLinkId: 0,
        literalId: 0,
        profileId: 0,
        accountPlatforms: [],
        accountTypes: [],
        accountLeverages: [],
        accountCurrencies: [],
      },
    };
  }

  componentDidMount(){



    //const { wizardData } = this.props;

    let configVars = store.getState().config;

    this.props.ibFetch(this.props.match.params.id);

    let myProfileId = 0;

    this.props.profileFetch(this.props.match.params.profileId).then((e1) => {
      
      myProfileId = this.props.match.params.profileId;

      this.setState({
          ...this.state,
          profileId: myProfileId,
        });

      this.props.referralLinksFetch(this.props.match.params.profileId, this.props.match.params.id)
        .then((e2) => {
      
        if (e2.content.length>0) {
        this.setState({
            ...this.state,
            referrallink:configVars['registrationAppUrl']+this.filterLiteralId(e2.content[e2.content.length-1].literalId),
            literalId: e2.content[e2.content.length-1].literalId,
            referralLinkId: e2.content[e2.content.length-1].referralLinkId,
            showCreateReferralLink: false,
            form:{
              ibId: this.props.match.params.id,
              profileId: myProfileId,
              referralLinkId: e2.content[e2.content.length-1].referralLinkId,
              literalId: e2.content[e2.content.length-1].literalId,
              accountPlatforms: e2.content[e2.content.length-1].accountPlatforms,
              accountTypes: e2.content[e2.content.length-1].accountTypes,
              accountLeverages: e2.content[e2.content.length-1].accountLeverages,
              accountCurrencies: e2.content[e2.content.length-1].accountCurrencies,
            }
          })
      }

      });

    });
  

    if (this.state.referrallink==='') {

      this.setState({
        ...this.state,
        showCreateReferralLink: true,
      });

      
    }
    

  }

  onChange(e, filter){

    let configVars = store.getState().config;

    let state = this.state
    let value = e.target.value

    if (filter==='referrallink') {

      let url = configVars['registrationAppUrl'];

      if (e.target.value.includes('='))
      {
        e.target.value = url+e.target.value.split("=").pop();
        state[filter] = e.target.value;
        state.literalId = 'MYSCOPE_REFERRALLINK_LITERAL_ID_'+e.target.value.split("=").pop()
        state.form.literalId = 'MYSCOPE_REFERRALLINK_LITERAL_ID_'+e.target.value.split("=").pop()

        state.form.accountPlatforms = this.props.wizardData.accountPlatforms;
        state.form.accountTypes = this.props.wizardData.accountTypes;
        state.form.accountLeverages = this.props.wizardData.accountLeverages;
        state.form.accountCurrencies = this.props.wizardData.accountCurrencies;

        this.setState({...state});
      } else {
        e.target.value = this.state.referrallink;
      }

      if (!this.state.showCreateReferralLink) {
        this.showCreateReferralLink();
      }

    
    } else {
      state[filter] = value
      this.setState({...state})
    }

  }

  showCreateReferralLink() {
    this.setState({
          ...this.state,
          showCreateReferralLink: true,
        });
  }

  createReferralLink() {

    let configVars = store.getState().config;

    this.props.referralLinkSave({'ibId':this.props.match.params.id,'profileId':this.props.match.params.profileId})
      .then((responseSave) => {
        
        this.setState({
          ...this.state,
          referrallink:'Loading...',
          showCreateReferralLink: true,
        });

        setTimeout(function() {

          this.props.referralLinkFetch(responseSave.referralLinkId)
          .then((responseFetch) => {
            this.setState({
              ...this.state,
              referrallink:configVars['registrationAppUrl']+this.filterLiteralId(responseFetch.literalId),
              showCreateReferralLink: false,
              form: {
                literalId:responseFetch.literalId
              }
            });

          });

        }.bind(this), 10000);

      });

  }

  filterLiteralId(literalId) {

    if (typeof literalId === 'string' || literalId instanceof String) {

      if (literalId.includes('_')) {
        
        let realLiteralId = literalId.split("_").pop();
        return realLiteralId;
      
      } else {

        return 0;
      
      }

    } else {

      return 0;
      
    }

    /*let realLiteralId = literalId.replace("MYSCOPE_EXTERNAL_IB_ID_", "");
    realLiteralId = literalId.replace("MYSCOPE_REFERRALLINK_LITERAL_ID_", "");
    return realLiteralId;*/

  }

  componentWillMount(){
    if(this.props.match.params.id){
      
    }
  }

  copyToClipboard() {
    var textField = document.createElement('textarea')
    textField.innerText = this.state.referrallink;
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy',false)
    textField.remove()
  }

  submit(e){
    e.preventDefault()
    
    let configVars = store.getState().config;

    var myProfileId = parseInt((parseInt(this.state.form.profileId,10)>0)?this.state.form.profileId:this.props.wizardData.profileId,10);

    //let data = {...this.props.wizardData, ...this.state.form}
    let data = {...this.props.wizardData, ...{ibId: this.props.match.params.id,
              profileId: (parseInt(this.state.form.profileId,10)>0)?this.state.form.profileId:this.props.wizardData.profileId,
              referralLinkId: this.state.form.referralLinkId,
              literalId: this.state.form.literalId,
              accountPlatforms: this.props.wizardData.accountPlatforms,
              accountTypes: this.props.wizardData.accountTypes,
              accountLeverages: this.props.wizardData.accountLeverages,
              accountCurrencies: this.props.wizardData.accountCurrencies,
            }}
    
    
    if(data.accountPlatforms === ''){
      delete data.accountPlatforms
    }
    if(data.accountTypes === ''){
      delete data.accountTypes
    }
    if(data.accountLeverages === ''){
      delete data.accountLeverages
    }
    if(data.accountCurrencies === ''){
      delete data.accountCurrencies
    }
    
    if (myProfileId>0)
    {
      this.props.saveEdit(data)
        .then(e => {
          this.props.saveWizardData(e)
          this.props.history.goBack();
      })
      .catch(e=>{
        //this.props.danger(e+'',4);
        this.props.referralLinkFetch(this.state.form.referralLinkId)
          .then((responseFetch) => {
            this.setState({
              ...this.state,
              referrallink:configVars['registrationAppUrl']+this.filterLiteralId(responseFetch.literalId),
              showCreateReferralLink: false,
              form: {
                literalId:responseFetch.literalId
              }
            });

          });

      })
    } else {
      //this.props.history.goBack();
    }
    
  }

  render() {
    //const { classes,wizardData } = this.props;
    //const { referrallink,showCreateReferralLink, form:{literalId} } = this.state;

    const { referrallink, form:{literalId} } = this.state;

    let configVars = store.getState().config;

    const partnerUrl = configVars['registrationAppUrl']+this.filterLiteralId(literalId);

    return (
      <GridContainer justify="center">
      <GridItem xs={12} style={{textAlign: 'center', margin: '40px 0',}}>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <div style={{
                  background: 'rgba(200, 200, 200, 0.2)',
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '20px',
                  width: '100%',
                  maxWidth: '600px'
              }}>
                <div style={{display:'flex', alignContent: 'left'}}>
                  <span style={{borderRadius: '50%', background:'#00acc1', width: '24px', height: '24px', color: 'white', padding: '1.5px'}}>
                    <Link style={{transform: 'rotate(50deg)', fontSize: 20}}/>
                  </span>
                  <span style={{marginLeft: '5px', color: 'gray'}}>
                    Get this link and <strong>send it</strong> to your client
                  </span>
                </div>
                {(referrallink==="Loading...") ?
              (<LinearProgress color="primary"/>)
              :
                <div style={{textAlign: 'left', padding: '10px 0', display: 'flex', alignItems:'center'}}>
                  <input
                    id="partner_link" 
                    name="partner_link" 
                    disabled={false}
                    style={{
                      padding: '15px',
                      width: '100%',
                      background: 'white',
                      border: '1px solid gray',
                      borderRadius: '5px'
                    }}
                    readOnly={false}
                    onChange={e => this.onChange(e,'referrallink')}
                    value={partnerUrl}
                  />
                  
                  <CopyToClipboard 
                    text={partnerUrl}
                    style={{marginLeft:'10px', cursor: 'pointer'}}
                  >
                    <FileCopyOutlined
                      style={{fontSize:20}}
                    />
                  </CopyToClipboard>
                </div>
              }
               { /*showCreateReferralLink &&
                <FormControl fullWidth className={classes.selectFormControl}>
                  <Button onClick={()=>this.createReferralLink()} color="info">Create Referral Link</Button>
                </FormControl>*/
                }
              </div>
            </div>
          </GridItem>
        {/*<GridItem xs={12} sm={12} md={12} lg={10}>
        <Card style={{backgroundColor: '#F4F4F4'}}>
            <CardHeader color="info" icon>
              <CardIcon color="info">
                <Link className={classes.inputAdornmentIcon} />
              </CardIcon>
              <h4 style={{color: '#000000'}} className={classes.cardIconTitle}>Get this Link and send it to your Client.</h4>
            </CardHeader>
            <CardBody>
              <form>
              {(referrallink==="Loading...") ?
              (<LinearProgress color="primary"/>)
              :
            <CustomInput
            value={referrallink}
            labelText={''}
            id="partner_link"
            formControlProps={{
              fullWidth: true
            }}
            readOnly={false}
            inputProps={{
              value: referrallink,
              readOnly: false,
              endAdornment: (
                <InputAdornment
                  position="end"
                  className={classes.inputAdornment}
                >
                  <Button color="white" onClick={()=>this.copyToClipboard()}><FileCopy className={classes.inputAdornmentIcon} /></Button>
                </InputAdornment>
              )
            }}
          />}
              { showCreateReferralLink &&
                <FormControl fullWidth className={classes.selectFormControl}>
                  <Button onClick={()=>this.createReferralLink()} color="info">Create Referral Link</Button>
                </FormControl>
              }
              </form>
            </CardBody>
          </Card>
          </GridItem>*/}
        <GridItem sm={11}>
          <div style={{float: 'left'}}>
            <Button
              // color="success"
              type="button"
              onClick={(e) => this.props.goToPreviousStep()}
              style={{position:'absolute', bottom:'10px', left:'40px'}}
            >
              Previous
            </Button>
          </div>
          <div style={{float: 'right'}}>
            <Button
              color="success"
              type="button"
              onClick={(e) => this.submit(e)}
              style={{position:'absolute', bottom:'10px', right:'40px'}}
            >
              Done
            </Button>
          </div>
        </GridItem>
      </GridContainer>
    );
  }
}

const state=(state)=>({
  ibs: state.ibs,
  referrallinks: state.referralLinks,
})
const dispatch=(dispatch)=>({
  saveEdit:(data)=>dispatch(referralLinkEditSave(data)),
  referralLinkFetch:(id)=>dispatch(referralLinkFetch(id)),
  referralLinksFetch:(profileId, ibId)=>dispatch(referralLinksFetch(profileId, ibId)),
  referralLinkSave:(data)=>dispatch(referralLinkSave(data)),
  referralLinkEditSave:(data)=>dispatch(referralLinkEditSave(data)),
  ibFetch:(id)=>dispatch(ibFetch(id)),
  profileFetch:(id)=>dispatch(profileFetch(id)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  
})
export default withStyles({...styles, ...regularFormsStyle})(connect(state,dispatch)(PartnerLinks))



// WEBPACK FOOTER //
// ./src/views/IbTree/Wizard/PartnerLinks.jsx